import { useEffect, useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Seo } from "../components/Seo";
import { getPublicStatus } from "../lib/api";

const LABELS = { api: "API", processamento: "Processamento de PDF", armazenamento: "Armazenamento" };

export default function StatusPage() {
    const [data, setData] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        getPublicStatus()
            .then(setData)
            .catch(() => setError(true));
    }, []);

    return (
        <main className="py-14 px-6 max-w-3xl mx-auto min-h-[60vh]">
            <Seo
                title="Status dos serviços — ScorpionPDF"
                description="Situação em tempo real da API, do processamento de PDFs e do armazenamento temporário."
            />
            <span className="font-mono-tag text-xs font-bold text-[#0284C7] uppercase">Monitoramento</span>
            <h1 className="font-poster text-5xl md:text-6xl text-black mt-1">Status</h1>

            {error && (
                <div className="mt-8 border-2 border-black bg-[#FEF2F2] p-6" role="alert" data-testid="status-error">
                    <p className="font-bold text-red-900 text-sm">Não foi possível consultar o status agora.</p>
                    <p className="text-xs text-red-800 mt-1">Se o problema persistir, o serviço pode estar em manutenção. Tente novamente em alguns minutos.</p>
                </div>
            )}
            {!data && !error && (
                <p className="mt-8 font-mono-tag text-sm text-gray-600 inline-flex items-center gap-2">
                    <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" /> Consultando serviços…
                </p>
            )}
            {data && (
                <div className="mt-8 space-y-4" data-testid="status-panel">
                    {Object.entries(data.servicos).map(([key, value]) => (
                        <div key={key} className="border-2 border-black bg-white p-5 flex items-center justify-between">
                            <span className="font-bold text-black text-sm">{LABELS[key] || key}</span>
                            <span className="inline-flex items-center gap-2 font-mono-tag text-xs font-bold uppercase text-[#0284C7]" data-testid={`status-${key}`}>
                                <CheckCircle2 className="w-4 h-4" aria-hidden="true" /> {value}
                            </span>
                        </div>
                    ))}
                    <div className="border-2 border-black bg-[#FAFAF9] p-5">
                        <p className="font-mono-tag text-xs text-gray-600">
                            Tarefas processadas neste ambiente: {Object.values(data.tarefas).reduce((a, b) => a + b, 0)} ·
                            Retenção máxima de arquivos: {data.retencao_minutos} minutos ·
                            Atualizado em {new Date(data.atualizado_em).toLocaleString("pt-BR")}
                        </p>
                    </div>
                    <p className="text-xs text-gray-500">
                        Não prometemos disponibilidade de 100%. Nosso compromisso é reduzir a frequência e a duração de
                        qualquer falha, com monitoramento contínuo.
                    </p>
                </div>
            )}
        </main>
    );
}
